/**
 * Formats a URL to be displayed in a user-friendly way.
 * - Remove the protocol (http://, https://) from the URL.
 * - Remove any trailing slashes from the URL.
 */
export function prettifyURL(url: string): string {
    try {
        const u = new URL(url);
        return `${u.hostname}${u.pathname === '/' ? '' : u.pathname}`;
    } catch {
        return url;
    }
}

/**
 * A React component that formats a URL to be displayed in a user-friendly way.
 */
export function PrettyURL(props: { children: string }) {
    return <>{prettifyURL(props.children)}</>;
}
